import React from 'react';
import { formatApiError } from '../../utils/errorMessage';

// A 403 on a dashboard card means "not available here" (a document gate,
// a household location, a read window), not a failure.
export const isLockedError = (error) => error?.response?.status === 403;

export const lockedReason = (error) => formatApiError(error, 'Not available for this location yet.');

export function LockedCard({ title, error }) {
  return (
    <div className="bg-gray-50 rounded-lg shadow p-6" data-testid="locked-card">
      <div className="text-sm text-gray-600">{title}</div>
      <div className="mt-1 text-sm text-gray-500"><span aria-hidden="true">🔒 </span>{lockedReason(error)}</div>
    </div>
  );
}
